import React from 'react'
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CrossImg from '../assets/cross_img.svg'

const BottomSheetModel = (props) => {
  const{ title, isOpen, onClose, children, style = {} } = props
  const theme = useTheme();

  const ModelHeader = () => {
    return (
      <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
        <Box sx={{ textAlign: "center", flex: "1", color: theme.palette.darkBlue.main, fontSize: "20px", fontWeight: theme.typography.fontWeightSemibold }}>{title}</Box>
        <img onClick={() => onClose()} src={CrossImg} alt='Cross' width={15} height={15} />
      </Box>
    )
  }

  return (
    <>
      {isOpen && <Box sx={theme.customStyles.bottomSheetModelOverlay} onClick={() => onClose()}></Box>}
      <Box sx={{...theme.customStyles.bottomSheetModel, bottom: isOpen ? "0" : "-100%", ...style}}>
        <Box sx={theme.customStyles.bottomSheetModelContent}>
          <ModelHeader/>
          {children}
        </Box>
      </Box>
    </>
  );
};

export default BottomSheetModel;
  
